var render = function render(){var _vm=this,_c=_vm._self._c;return _c('loader',{staticClass:"bar"},[_c('div'),_c('div'),_c('div')])
}
var staticRenderFns = []

export { render, staticRenderFns }